import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
 
}
const serviceRequestJob = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default serviceRequestJob;